(() => {
  const protectedMediaSelector =
    'img, picture, .media, .card__media, .product__media-wrapper, .product-media-modal';

  const isProtectedMedia = (target) =>
    target instanceof Element && Boolean(target.closest(protectedMediaSelector));

  const protectImages = (root = document) => {
    root.querySelectorAll('img').forEach((image) => {
      image.draggable = false;
      image.setAttribute('draggable', 'false');
    });
  };

  document.addEventListener(
    'contextmenu',
    (event) => {
      if (isProtectedMedia(event.target)) event.preventDefault();
    },
    true
  );

  document.addEventListener(
    'dragstart',
    (event) => {
      if (isProtectedMedia(event.target)) event.preventDefault();
    },
    true
  );

  document.addEventListener(
    'selectstart',
    (event) => {
      if (isProtectedMedia(event.target)) event.preventDefault();
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => protectImages(), { once: true });
  } else {
    protectImages();
  }

  document.addEventListener('shopify:section:load', (event) => protectImages(event.target));
})();
